<template>
  <div class="select-wrapper">
    <multiselect
      v-model="value"
      :options="options"
      :placeholder="placeholder"
      :label="label"
      track-by="id"
      :multiple="multiselect"
      :close-on-select="!multiselect"
      @input="selectValue"
      :clear-on-select="false"
      :preserve-search="true"
      :show-labels="false"
    >
      <template slot="selection" slot-scope="{ values, search, isOpen }">
        <span class="multiselect__single" v-if="values.length && !isOpen" style="font-weight: 600;">{{ placeholder }} ({{values.length}})</span>
        <template slot="tag">
          <span class="multiselect__tag"></span>
        </template>
      </template>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'SelectMultiple',
  props: {
    options: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: 'name'
    },
    multiselect: {
      type: Boolean,
      default: false
    },
    paraName: {
      type: String,
      required: true
    }
  },
  components: {
    Multiselect
  },
  data: () => ({
    value: []
  }),
  watch: {},
  methods: {
    removeAll () {
      this.value = null
    },
    selectValue (value) {
      this.$emit('updateValue', value)
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="less" scoped>
  /deep/.multiselect {
    &__placeholder {
      color: #000;
    }

    &__option {
      &--highlight {
        background: #4a5d5c;
      }
    }

    &__tag {
      background: #4a5d5c;
      // display: none;

      &-icon {
        &:hover {
          background: darken(#4a5d5c, 20%);
        }
        &::after {
          color: #fff;
        }
      }
    }
  }
</style>
